export default {
  TempoAtingimentoTemperaturaAlarme: 'engineering.final-gradient.parameters.temperature-alarm-reach-time',
  TempoAtingimentoTemperaturaAlarmeLabel: 'engineering.final-gradient.parameters.temperature-alarm-reach-time-label',
  TempoAtingimentoTemperaturaDesligamento: 'engineering.final-gradient.parameters.temperature-shutdown-reach-time',
  TempoAtingimentoTemperaturaDesligamentoLabel: 'engineering.final-gradient.parameters.temperature-shutdown-reach-time-label',
};
